import { render } from "./RegisterView.vue?vue&type=template&id=24073dc6&scoped=true"
import script from "./RegisterView.vue?vue&type=script&lang=js"
export * from "./RegisterView.vue?vue&type=script&lang=js"

import "./RegisterView.vue?vue&type=style&index=0&id=24073dc6&lang=scss"
import "./RegisterView.vue?vue&type=style&index=1&id=24073dc6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24073dc6"]])

export default __exports__